import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { Button, usePopover, PopoverMenu } from '@gem/ui-kit';

import { useUnknownUserBlockPresenter } from './UnknownUserBlock.presenter';

interface IUnknownUserBlockProps {
  className?: string;
  groupId: string;
  userId: string;
}

export const UnknownUserBlock: FC<IUnknownUserBlockProps> = observer((props) => {
  const { className, groupId, userId } = props;
  const { t } = useTranslation();
  const popover = usePopover<HTMLButtonElement>();

  const presenter = useUnknownUserBlockPresenter({ userId, groupId, popover });

  return (
    <>
      <Button
        setRef={popover.containerRef}
        onClick={popover.toggle}
        className={className}
        theme="text-error"
      >
        {t('common_block')}
      </Button>
      <PopoverMenu
        placement="bottom-start"
        menuItems={presenter.menuItems}
        reference={popover.containerRef.current}
        isOpened={popover.isOpened}
        onClose={popover.close}
      />
    </>
  );
});
